import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Checkout from './components/pages/checkout';
import PaymentLinkNavigator from './components/pages/payment_link_navigator';
import CheckoutPrem from './components/pages/checkout_prem';
import Iframes from './components/pages/iframes';
import Handle_3d from './components/pages/handle_3d';
import Redirection_complete from './components/pages/redirection_complete';
import OmanNet from './components/modules/iframes/paymentMethods/OmanNet/OmanNet'
import { withProfiler } from '@sentry/react';
import './App.css';

class App extends Component {
    //PaymentLinkNavigator contains flash_checkout and payment_links
  render() {
    console.log("version: 2.2");
    return (
      <div className="App">
        <BrowserRouter>
          <Switch>
            <Route path="/standalone" component={Checkout} />
            <Route path="/standalone_prem" component={Checkout} />
            <Route path="/iframe/handle_3d/" component={Handle_3d} />
            <Route path="/iframe/redirection_complete/" component={Redirection_complete} />
            <Route path="/iframe/:payment_token?/" component={Iframes} />
            <Route path="/flash" component={PaymentLinkNavigator} />
            <Route path ="/omannet" component={OmanNet}/>
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default withProfiler(App);
